import React from 'react';
import { useEffect, useState } from 'react';
import ExamCreation from '../../modules/exam/ExamCreation';
import { QuestionGenerationParams } from './list/core/_models'
import { CustomCreateExam, getCourseOutcomesForSemesterCourse } from './list/core/_requests'
import { useLocation, useNavigate } from 'react-router-dom';
import { Model as CourseOutcome } from '../courseoutcome/list/core/_models'
import Swal from 'sweetalert2';
import type {ExamDeliveryMethod} from './core/examDeliveryMethod'

const CreateExam = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const item: any = location.state
    console.log(item)
    const [outcomes, setOutcomes] = useState<CourseOutcome[]>([]);
    const course = {
        id: item.courseId,
        name: item.name,
        isExamDeliveryMethodEnabled: Boolean(item?.isExamDeliveryMethodEnabled),
    };

    useEffect(() => {
        const loadOutcomes = async () => {
            const rawId = item?.semesterCourseId ?? item?.id
            const parsedId = typeof rawId === 'string' ? Number(rawId) : rawId

            if (typeof parsedId !== 'number' || Number.isNaN(parsedId)) {
                setOutcomes([])
                return
            }

            try {
                const response = await getCourseOutcomesForSemesterCourse(parsedId)
                setOutcomes(response ?? [])
            } catch (error) {
                console.error(error)
                setOutcomes([])
            }
        }

        if (item != undefined) {
            loadOutcomes()
        }
    }, [item]);


    const handleSubmit = (
        params: QuestionGenerationParams[],
        examDetails: {
            instructions: string;
            examType: number;
            contributionPercentage: number;
            examDurationMinutes?: number | null;
            examDeliveryMethod?: ExamDeliveryMethod | null;
        }
    ) => {
        // Backend'e verileri gönderiyoruz
        const payload = {
            questionParams: params,
            semesterCourseId: item.id,
            contributionPercentage: examDetails.contributionPercentage,
            examTypeId: examDetails.examType,
            instructions: examDetails.instructions,
            durationInMinutes: examDetails.examDurationMinutes,
            examDeliveryMethod: examDetails.examDeliveryMethod
        };

        CustomCreateExam(payload)
            .then(({data}) => {
                console.log('Exam created successfully:', data)
                if (typeof data === 'string' && data.startsWith('Hata')) {
                    Swal.fire({
                        title: 'Hata!',
                        text: data,
                        icon: 'error',
                        confirmButtonText: 'Tamam',
                    })
                    return
                }

                Swal.fire({
                    title: 'Başarılı!',
                    text: 'Sınav başarıyla oluşturuldu.',
                    icon: 'success',
                    confirmButtonText: 'Tamam',
                })
                navigate('dashboard')
            })
            .catch(error => {
                console.error('There was an error creating the exam:', error);
                Swal.fire({
                    title: 'Hata!',
                    text: error?.response?.data || 'İşlem sırasında bir hata oluştu.',
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            });
    };

return (
    <div>
        {outcomes.length > 0 && <ExamCreation course={course} outcomes={outcomes} onSubmit={handleSubmit} />}
    </div>
    )
};

export default CreateExam;
